import { Row, Col } from 'reactstrap';
import { FormattedMessage, useIntl } from 'react-intl';

import Edit from 'src/componentes/edit/edit-dialog';
import { Schema } from 'src/utils/form';
import { capitalizeFirstLetter } from 'src/utils/string';
import CausaRiscoLookup from 'src/lookups/causa-risco';
import useAuth from 'src/hooks/useAuth';

let schema = Schema.object({
  causa: Schema.string()
    .label(<FormattedMessage id="descricao" />)
    .required(),
});

const FormEdit = ({ model, disabled, riscoId }) => (
  <div>
    <br />
    <Row>
      <Col md={12}>
        <Col md={8}>
          <CausaRiscoLookup
            disabled={disabled}
            model={model.getModel('causa')}
            data={{ riscoId: riscoId }}
          />
        </Col>
      </Col>
    </Row>
  </div>
);

const CausaEventoRiscoEdit = (props) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <Edit
      {...props}
      parameters={{ eventoRiscoId: props.eventoRiscoId }}
      title={capitalizeFirstLetter(
        intl.formatMessage(
          { id: 'labelCausasDoRisco' },
          {
            pontosproblematicos: resources.pontosproblematicos,
            risco: resources.risco,
          }
        )
      )}
      formComponent={FormEdit}
      afterSave={props.afterSave && props.afterSave}
      schema={schema}
      showActions={true}
      width={600}
      minHeight={240}
    />
  );
};

export default CausaEventoRiscoEdit;
